const FEATURE_LIST = {
  layout: 'GRID',
  features: [
    {
      id: "SCREEN_FILTERS",
      type: "screen",
      title: "פילטרים",
      options: {
        isOpen: true,
        selectedId: null
      }
    }, { 
      id: "CURSOR_STYLE",
      type: "generals",
      title: "סיגנון סמן",
      options: {
        isOpen: true,
        selectedId: null
      }
    }, {
      id: "FONT_SIZE",
      type: "font",
      title: "גודל גופן",
      options: {
        isOpen: true,
        size: 0
      }
    }, { 
      id: "BACKGROUND_COLOR",
      type: "color",
      title: "צבע רקע",
      options: {
        isOpen: true,
        selectedId: null
      }
    }, { 
      id: "TOOL_TIP",
      type: "generals",
      title: "כלי הסבר",
      options: {
        isOpen: true,
        isToggleOn: false
      }
    }, { 
      id: "HIGHLIGHT_TITLES",
      type: "title",
      title: "הדגש כותרות",
      options: {
        isOpen: true,
        isToggleOn: false
      }
    }, { 
      id: "FONT_FAMILY",
      type: "font",
      title: "שינוי גופן",
      options: {
        isOpen: true,
        selectedId: null
      }
    }, { 
      id: "FONT_COLOR",
      type: "color",
      title: "צבע טקסט",
      options: {
        isOpen: true,
        selectedId: null
      }
    }, { 
      id: "HIGHLIGHT_LINKS",
      type: "link",
      title: "הדגש קישורים",
      options: {
        isOpen: true,
        isToggleOn: false
      }
    }
  ]
};

export { FEATURE_LIST };


// WEBPACK FOOTER //
// ./src/constants/featuresList.js